// ── Mobile menu ──
const burger = document.getElementById('burger');
const mobileMenu = document.getElementById('mobileMenu');

if (burger && mobileMenu) {
  burger.addEventListener('click', () => {
    const isOpen = burger.classList.toggle('open');
    mobileMenu.style.display = isOpen ? 'flex' : 'none';
    requestAnimationFrame(() => mobileMenu.classList.toggle('open', isOpen));
    document.body.style.overflow = isOpen ? 'hidden' : '';
    burger.setAttribute('aria-expanded', isOpen);
  });
}

function closeMobileMenu() {
  if (!burger || !mobileMenu) return;
  burger.classList.remove('open');
  mobileMenu.classList.remove('open');
  mobileMenu.style.display = 'none';
  document.body.style.overflow = '';
  burger.setAttribute('aria-expanded', false);
}

// ── Gallery slider ──
const gTrack = document.getElementById('gTrack');
if (gTrack) {
  const gDotEls = document.querySelectorAll('#gDots .dot');
  let gCurrent = 0;
  const CELL_W = 405 + 32;

  function gTo(n) {
    const max = Math.max(0, gTrack.children.length - 1);
    gCurrent = Math.max(0, Math.min(n, max));
    gTrack.style.transform = `translateX(-${gCurrent * CELL_W}px)`;
    gDotEls.forEach((d, i) => d.classList.toggle('off', i !== gCurrent));
  }

  document.getElementById('gNext')?.addEventListener('click', () => gTo(gCurrent + 1));
  document.getElementById('gPrev')?.addEventListener('click', () => gTo(gCurrent - 1));
  gDotEls.forEach(d => d.addEventListener('click', () => gTo(+d.dataset.i)));
}

// ── Testimonials slider ──
const tCards = document.querySelectorAll('.t-card');
if (tCards.length > 0) {
  const tDotEls = document.querySelectorAll('#tDots .dot');
  let tCurrent = 0;

  function tTo(n) {
    tCurrent = (n + tCards.length) % tCards.length;
    tCards.forEach((c, i) => c.classList.toggle('t-card--hidden', i !== tCurrent));
    tDotEls.forEach((d, i) => d.classList.toggle('off', i !== tCurrent));
  }

  document.getElementById('tNext')?.addEventListener('click', () => tTo(tCurrent + 1));
  document.getElementById('tPrev')?.addEventListener('click', () => tTo(tCurrent - 1));
  tDotEls.forEach(d => d.addEventListener('click', () => tTo(+d.dataset.t)));
}

// ── Header scroll shadow ──
(function () {
  const hdr = document.querySelector('header');
  if (!hdr) return;
  let ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        hdr.classList.toggle('scrolled', window.scrollY > 60);
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

// ── Scroll reveal ──
(function () {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Elements to reveal on scroll (auto-tagged — no liquid changes needed)
  const REVEAL_SELECTORS = [
    '.stats-title',
    '.stat',
    '.services-hdr',
    '.services-img',
    '.svc',
    '.gallery-wrap > h2',
    '.gallery-slider',
    '.clients-lhs',
    '.t-card',
    '.products-hdr',
    '.p-card',
  ];

  // Add .reveal class programmatically
  REVEAL_SELECTORS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      el.classList.add('reveal');
    });
  });

  // Stagger siblings in these containers (80ms per child)
  var STAGGER_GROUPS = ['.stats-grid', '.services-cols', '.products-grid'];
  STAGGER_GROUPS.forEach(function (groupSel) {
    var group = document.querySelector(groupSel);
    if (!group) return;
    Array.from(group.children).forEach(function (child, i) {
      child.dataset.revealDelay = i * 80;
    });
  });

  // Instant-show if reduced motion
  if (prefersReduced) {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = Number(el.dataset.revealDelay) || 0;
      setTimeout(function () {
        el.classList.add('is-visible');
        // Free GPU memory after transition completes
        setTimeout(function () { el.style.willChange = 'auto'; }, 850);
      }, delay);
      revealObserver.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -32px 0px' });

  document.querySelectorAll('.reveal').forEach(function (el) {
    revealObserver.observe(el);
  });
})();

// ── Stat counter animation ──
const statsSection = document.querySelector('.stats');
const counterEls = document.querySelectorAll('.num[data-target]');

if (statsSection && counterEls.length > 0) {
  function animateCounter(el) {
    const target = +el.dataset.target;
    const duration = 1800;
    const start = performance.now();
    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(eased * target) + '%';
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  let countersRun = false;
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && !countersRun) {
      countersRun = true;
      counterEls.forEach(el => animateCounter(el));
    }
  }, { threshold: 0.3 });

  observer.observe(statsSection);
}
